import React from 'react';
import { cn } from '@/lib/utils';
import Icon, { IconComponent } from './Icon';

interface EmptyStateProps {
  icon: IconComponent;
  title: string;
  description: string;
  /** Next step, e.g. a "File a claim" button. */
  action?: React.ReactNode;
  className?: string;
}

/** Card for a list with nothing in it yet (Figma "Result state" in empty mode). */
const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action, className }) => (
  <section className={cn('tw-flex tw-flex-col tw-items-center tw-gap-4 tw-rounded-2xl tw-border tw-border-ds-border-default tw-bg-ds-surface tw-px-6 tw-py-8 tw-text-center md:tw-px-8', className)}>
    <span className="tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-full tw-bg-ds-subtle">
      <Icon icon={icon} size={26} className="tw-text-ds-text-secondary" />
    </span>
    <div className="tw-flex tw-flex-col tw-gap-2">
      <h2 className="tw-text-[22px] tw-font-bold tw-leading-7 tw-text-ds-text-primary">{title}</h2>
      <p className="tw-max-w-md tw-text-[14px] tw-leading-5 tw-text-ds-text-secondary">{description}</p>
    </div>
    {action}
  </section>
);

export default EmptyState;
